import styled from 'styled-components';
import { theme } from 'lib';

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: ${theme.GREY_10};
  border-radius: 12px;
  margin-bottom: 16px;
`;

export const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid ${theme.GREY_20};

  &:last-child {
    border-bottom: none;
  }
`;

export const ScoreDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 32px;
  background: linear-gradient(135deg, ${theme.GREY_10} 0%, #f8f9fa 100%);
  border-radius: 16px;
  margin: 24px 0;
`;

export const TeamScore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const Score = styled.div`
  font-size: 48px;
  font-weight: 700;
  color: ${(props) => props.color || theme.GREY_80};
`;

export const StatusBadge = styled.div`
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  background: ${(props) => {
    switch (props.status) {
      case 'scheduled':
        return theme.GREY_20;
      case 'in-play':
        return '#4CAF50';
      case 'finished':
        return theme.GREY_40;
      case 'postponed':
        return '#FF9800';
      case 'canceled':
        return '#F44336';
      default:
        return theme.GREY_20;
    }
  }};
  color: ${(props) =>
    ['in-play', 'canceled', 'postponed', 'finished'].includes(props.status)
      ? '#fff'
      : theme.GREY_80};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
`;

export const TeamsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: auto auto auto;
  gap: 16px 24px;
  padding: 32px;
  background: ${theme.GREY_10};
  border-radius: 16px;
  margin: 24px 0;
  align-items: center;
`;

export const GridCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${(props) => (props.hasGap ? '8px' : '0')};
`;

export const PredictionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  border-bottom: 1px solid ${theme.GREY_20};
  background: #fff;
  transition: background 0.2s ease;

  &:hover {
    background: ${theme.GREY_10};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const PredictionScore = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: ${theme.GREY_80};
`;

export const PointsBadge = styled.div`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) => (props.isCorrect ? '#4CAF50' : theme.GREY_20)};
  color: ${(props) => (props.isCorrect ? '#fff' : theme.GREY_80)};
`;

export const WinnerBadge = styled.div`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${theme.GREY_20};
  color: ${theme.GREY_80};
  text-transform: capitalize;
`;

export const VoteItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid ${theme.GREY_20};
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: ${theme.GREY_10};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const CommentItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: white;
  transition: background 0.2s ease;

  &:hover {
    background: ${theme.GREY_10};
  }
`;

export const CommentContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CommentBubble = styled.div`
  background: ${theme.GREY_10};
  padding: 10px 14px;
  border-radius: 18px;
  display: inline-block;
  max-width: fit-content;
`;

export const CommentActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
  padding-left: 14px;
`;

export const ViewRepliesButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: ${theme.SECONDARY};
  transition: color 0.2s ease;

  &:hover {
    text-decoration: underline;
  }
`;

export const ReactionEmoji = styled.span`
  font-size: 14px;
  line-height: 1;
`;

export const CommentBubbleWrapper = styled.div`
  position: relative;
  max-width: fit-content;
`;

export const ReplyItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 8px 16px 8px 52px;
  background: white;
  transition: background 0.2s ease;

  &:hover {
    background: ${theme.GREY_10};
  }
`;

export const CommentMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  padding-left: 14px;
`;

export const ReactionsDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  background: white;
  border-radius: 12px;
  border: 1px solid ${theme.GREY_20};
  font-size: 12px;
  position: absolute;
  bottom: -8px;
  right: -18px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.GREY_10};
    border-color: ${theme.GREY_40};
  }
`;

export const ReactionUserItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  transition: background 0.15s ease;
  cursor: pointer;

  &:hover {
    background: ${theme.GREY_10};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ReactionFilterButton = styled.button`
  background: transparent;
  color: ${(props) => (props.active ? '#1877F2' : theme.GREY_60)};
  border: none;
  padding: 8px 12px;
  font-size: 15px;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  position: relative;
  border-bottom: ${(props) => (props.active ? '2px solid #1877F2' : '2px solid transparent')};
  margin-bottom: -1px;

  &:hover {
    background: ${theme.GREY_10};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const ReactionsModalContent = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  min-height: 400px;
`;

export const ReactionsFilterSection = styled.div`
  padding: 0;
  border-bottom: 1px solid ${theme.GREY_20};
  background: #fff;
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ReactionsListSection = styled.div`
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.GREY_30};
    border-radius: 4px;

    &:hover {
      background: ${theme.GREY_40};
    }
  }
`;

export const UserInfoWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const UserName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${theme.GREY_80};
  line-height: 1.33;
`;

export const UserUsername = styled.div`
  font-size: 13px;
  color: ${theme.GREY_60};
  line-height: 1.38;
`;

export const AvatarWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const ReactionEmojiOverlay = styled.div`
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  font-size: 14px;
  line-height: 1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const CandidateItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid ${theme.GREY_20};
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PlayerName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${theme.GREY_80};
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
`;

export const StatValue = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${theme.PRIMARY};
`;

export const StatLabel = styled.div`
  font-size: 11px;
  color: ${theme.GREY_60};
  text-transform: uppercase;
`;

export const PlayerSelectItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid ${theme.GREY_20};
  cursor: pointer;
  background: ${(props) => (props.selected ? '#e7f3ff' : 'transparent')};
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (props.selected ? '#d0e8ff' : theme.GREY_10)};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const SelectionCircle = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.selected ? '#4CAF50' : theme.GREY_40)};
  background: ${(props) => (props.selected ? '#ffffff' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;

  &::after {
    content: '✓';
    color: #4caf50;
    font-size: 16px;
    font-weight: 900;
    display: ${(props) => (props.selected ? 'block' : 'none')};
  }
`;
